module.exports = __webpack_public_path__ + "img/bubble-yellow.72835771.svg";